import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MappaComponent} from "./mappa/mappa.component";
import { SelezionaClientiComponent } from './seleziona-clienti/seleziona-clienti.component';
import { ListaClientiComponent } from './lista-clienti/lista-clienti.component';
import {AgmCoreModule} from "../../LibrerieCustom/agm-core-1.1.0";
import {FeatherModule} from "angular-feather";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxChartsModule} from "@swimlane/ngx-charts";
import {TranslateModule} from "@ngx-translate/core";



@NgModule({
  declarations: [MappaComponent, SelezionaClientiComponent, ListaClientiComponent],
  imports: [
    CommonModule,
    FeatherModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgxChartsModule,
    TranslateModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyAtHf7gRjLvTbRzwUy4GQ-87hNa--almW0'
    }),
  ],
  exports:[
    SelezionaClientiComponent
  ]
})
export class MappaModule { }
